import React from 'react';
import { Flex, Link } from 'components/ui';
import { wrapFunctionalComponent } from 'utils/framework';
import { colors, space, radii } from 'style/config';
import Empty from 'constants/empty';
import localeUtils from 'utils/LanguageLocale';
import OOSAlternateLinkEN from 'components/RwdBasket/Carts/CartLayout/SkuItem/OOSAlternateLink/locales/OOSAlternateLink_en_US';
import OOSAlternateLinkFR from 'components/RwdBasket/Carts/CartLayout/SkuItem/OOSAlternateLink/locales/OOSAlternateLink_fr_CA';
const getText = localeUtils.getLocalisedDataFromResource(OOSAlternateLinkEN, OOSAlternateLinkFR);
import skuUtils from 'utils/Sku';

const styles = {
    salePriceText: {
        color: colors.red
    },
    originalPriceText: {
        fontWeight: 'var(--font-weight-normal)',
        textDecoration: 'line-through'
    },
    skuDeleteWrapper: {
        justifyContent: 'center',
        alignItems: 'center',
        width: space[5],
        height: space[5],
        borderRadius: radii.full,
        border: `1px solid ${colors.midGray}`,
        cursor: 'pointer'
    },
    iconBox: {
        width: space[3],
        height: space[3]
    }
};

const OOSAlternateLink = ({ item, isOutOfStock = false, clickHandler = Empty.function }) => {
    const shouldRenderOOSAlternativeLink = () => {
        // Main Kill Switch used to hide/show the OOS Alternate Link feature
        const oosAlternateLinkKS = Sephora.configurationSettings?.isSelectAlternateForSamples?.isEnabled || false;

        if (!oosAlternateLinkKS) {
            return false;
        }

        const isSample = skuUtils.isSample(item.sku);
        const isBiReward = skuUtils.isBiReward(item.sku);
        const isPDPSample = skuUtils.isPDPSample(item.sku);
        const isGwpSample = skuUtils.isGwp(item.sku);
        const isBirthdayReward = skuUtils.isBirthdayGift(item.sku);
        const isBiRewardOver750 = skuUtils.isBiRewardOver750Points(item.sku);

        if (isPDPSample || isBirthdayReward || isBiRewardOver750 || isGwpSample) {
            return false;
        }

        return isOutOfStock && (isSample || isBiReward);
    };

    const handleOOSAlternativeClick = e => {
        e.stopPropagation();

        if (typeof clickHandler === 'function') {
            clickHandler();
        }
    };

    const oosAlternateLinkKS = shouldRenderOOSAlternativeLink();

    // When Kill Switch if off, the component will not be rendered at all.
    if (!oosAlternateLinkKS) {
        return null;
    }

    // Checks the Kill Switch is enabled before rendering the component.
    return (
        <>
            <Flex
                color={colors.red}
                marginTop={3}
                fontSize={['sm', 'base']}
                fontWeight={'bold'}
            >
                {'-'}
            </Flex>
            <Flex
                marginTop={4}
                fontSize={['sm', 'base']}
            >
                <Link
                    color='blue'
                    underline={true}
                    css={styles.link}
                    onClick={handleOOSAlternativeClick}
                >
                    {getText('oosAlternateLinkLegend')}
                </Link>
            </Flex>
        </>
    );
};

export default wrapFunctionalComponent(OOSAlternateLink, 'OOSAlternateLink');
